export default __webpack_public_path__ + "static/media/talent-main-section-flexera-Dev-IT.23d7f629.png";